import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import History from './history-model'
import {
  CreateHistoryAsync,
  DeleteHistoryAsync,
  LoadHistorysAsync,
} from './history-thunk'
const initialState: historySliceState = {
  history: [],
  selected_history: '',
  is_loading_history: false,
  is_creating_history: false,
  is_deleting_history: false,
}
export interface historySliceState {
  history: History[]
  selected_history?: string
  is_loading_history: boolean
  is_creating_history: boolean
  is_deleting_history: boolean
}
export const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setSelectedhistory: (state, action) => {
      state.selected_history = action.payload
    },
    clearStatehistory: (state) => {
      state.history = []
      state.is_loading_history = false
      state.is_creating_history = false
      state.is_deleting_history = false
    },
    mergehistory: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_history = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.history = merge(state.history, payload) as any
        }
      }
    },

    add_history: (state, action) => {
      if (action.payload) {
        state.history = [...state.history, action.payload]
      }
    },
    set_history: (state, action) => {
      let { key, value, id } = action.payload
      state.history = state.history.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadHistorysAsync.pending, (state) => {
      state.is_loading_history = true
    })
    builder.addCase(LoadHistorysAsync.fulfilled, (state, action) => {
      state.is_loading_history = false
      if (action.payload) {
        state.history = action.payload
      }
    })
    builder.addCase(LoadHistorysAsync.rejected, (state) => {
      state.is_loading_history = false
    })
    builder.addCase(CreateHistoryAsync.pending, (state) => {
      state.is_creating_history = true
    })
    builder.addCase(CreateHistoryAsync.fulfilled, (state) => {
      state.is_creating_history = false
    })
    builder.addCase(CreateHistoryAsync.rejected, (state) => {
      state.is_creating_history = false
    })
    builder.addCase(DeleteHistoryAsync.pending, (state) => {
      state.is_deleting_history = true
    })
    builder.addCase(DeleteHistoryAsync.fulfilled, (state, action) => {
      state.is_deleting_history = false
      if (state.history) {
        state.history = state.history.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteHistoryAsync.rejected, (state) => {
      state.is_deleting_history = false
    })

    builder.addCase(autoThunks.get_profile_history.pending, (state) => {
      state.is_loading_history = true
    })
    builder.addCase(
      autoThunks.get_profile_history.fulfilled,
      (state, action) => {
        state.is_loading_history = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_profile_history.rejected, (state) => {
      state.is_loading_history = false
    })
  },
})

function handleResult(action: any, state: historySliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_history = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.history = merge(state.history, payload) as any
    }
  }
}

export const {
  clearStatehistory,
  setSelectedhistory,
  set_history,
  mergehistory,
  add_history,
} = historySlice.actions

export const get_history =
  (id?: string) =>
  (state: {
    history: {
      history: History[]
    }
  }): History | null => {
    let temp = state?.history?.history?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.history?.history[0] || null
  }
export const get_selected_history = (state: {
  history: historySliceState
}): History | null => {
  let id = state?.history?.selected_history
  let temp = state?.history?.history?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_history = (state: {
  history: {
    history: History[]
  }
}): History[] => {
  let temp = state?.history?.history
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_history_busy = (state: { history: historySliceState }) => {
  return (
    state?.history.is_deleting_history ||
    state?.history.is_loading_history ||
    state?.history.is_creating_history
  )
}
export const is_deleting_history_busy = (state: {
  history: historySliceState
}) => {
  return state?.history.is_deleting_history
}
export const is_loading_history_busy = (state: {
  history: historySliceState
}) => {
  return state?.history.is_loading_history
}
export const is_creating_history_busy = (state: {
  history: historySliceState
}) => {
  return state?.history.is_creating_history
}

export default historySlice.reducer
